module.exports = __webpack_public_path__ + "img/1.34b0ca8f.png";